const getPaywallSeoClass = ({ className = "paywall", index = 3 }, nodeIndex) => nodeIndex < index && className;
const isPaywallSeo = (seoMode) => typeof seoMode === "object" && typeof seoMode?.paywall === "object";
export {
  getPaywallSeoClass,
  isPaywallSeo
};
//# sourceMappingURL=paywall-seo.js.map
